var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9062 0.875C13.0625 0.75 13.2812 0.75 13.4375 0.875L13.7812 1.25C13.9375 1.375 13.9375 1.625 13.7812 1.78125L4.40625 11.1562C4.28125 11.2812 4.03125 11.2812 3.90625 11.1562L0.1875 7.4375C0.03125 7.28125 0.03125 7.03125 0.1875 6.90625L0.53125 6.53125C0.6875 6.40625 0.90625 6.40625 1.0625 6.53125L4.15625 9.625L12.9062 0.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIcon);
export default __webpack_public_path__ + "static/media/selectIcon.17de54d32844ae138c8cf5715ad14525.svg";
export { ForwardRef as ReactComponent };